module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "selectCurrency": {
    "name": "select-currency",
    "class": "interaction",
    "properties": {
      "currency": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "externalLinkClick": {
    "name": "external-link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "bizObjectiveClick": {
    "name": "biz-objective-click",
    "class": "interaction",
    "properties": {
      "bizObjectiveKey": "string",
      "isLink": "boolean",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "clickMerchSelectionButton": {
    "name": "click-merch-selection-button",
    "class": "interaction",
    "properties": {
      "productName": "string",
      "trackingSource": "string",
      "currency": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "modalInteraction": {
    "name": "modal-interaction",
    "class": "interaction",
    "properties": {
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "modalName": "string",
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "faqClickQuestionExpansion": {
    "name": "faq-click-question-expansion",
    "class": "interaction",
    "properties": {
      "questionKey": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "bannerInteraction": {
    "name": "banner-interaction",
    "class": "interaction",
    "properties": {
      "name": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "clickToViewModal": {
    "name": "click-to-view-modal",
    "class": "interaction",
    "properties": {
      "edition": {
        "type": "string",
        "isOptional": true
      },
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "name": "string",
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "inCalculator": {
        "type": "boolean",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "termSelectorInteraction": {
    "name": "term-selector-interaction",
    "class": "interaction",
    "properties": {
      "term": "string",
      "action": "string",
      "trackingSource": "string",
      "discountShown": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "addonsAndServicesInteraction": {
    "name": "addons-and-services-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "phoneNumberClick": {
    "name": "phone-number-click",
    "class": "interaction",
    "properties": {
      "phoneNumber": "string",
      "phoneSourceId": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "communicationMethodsInteraction": {
    "name": "communication-methods-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "chat-shown",
        "chat-conversation-started",
        "phone-element-shown",
        "phone-element-clicked"
      ],
      "phoneNumber": {
        "type": "string",
        "isOptional": true
      },
      "phoneSourceId": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "scrollInteraction": {
    "name": "scroll-interaction",
    "class": "interaction",
    "properties": {
      "edition": {
        "type": "string",
        "isOptional": true
      },
      "name": "string",
      "action": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "conversations": {
    "name": "conversations",
    "class": "interaction",
    "properties": {
      "action": [
        "conversation-started",
        "clicked-chat-with-sales"
      ],
      "formattedExperimentArray": {
        "type": "array",
        "isOptional": true
      },
      "conversationId": {
        "type": "number",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "additionalUnitsPicker": {
    "name": "additional-units-picker",
    "class": "interaction",
    "properties": {
      "trackingSource": "string",
      "unitType": [
        "CONTACT",
        "MARKETING_CONTACT",
        "USER",
        "UNIT"
      ],
      "productLine": "string",
      "productLevel": "string",
      "ownsProduct": "boolean",
      "skuId": "number",
      "ownedUnitQuantity": "number",
      "displayedUnitQuantity": "number",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "linkClick": {
    "name": "link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "trackingSource": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "shoppingCartInteraction": {
    "name": "shopping-cart-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "skuId": "number",
      "productName": "string",
      "screen": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "confirmContactsRedirectClick": {
    "name": "confirm-contacts-redirect-click",
    "class": "interaction",
    "properties": {
      "merchandise_id": {
        "type": "string",
        "isOptional": true
      },
      "productNames": "array",
      "skuIds": "array",
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "confirmContactsRedirectButtonInteraction": {
    "name": "confirm-contacts-redirect-button",
    "class": "interaction",
    "properties": {
      "action": "string",
      "trackingSource": "string",
      "isSidegrade": {
        "type": "boolean",
        "isOptional": true
      },
      "merchandise_id": {
        "type": "string",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "buyAdditionalContacts": {
    "name": "buy-additional-contacts",
    "class": "interaction",
    "properties": {
      "trackingSource": "string",
      "productNames": "array",
      "skuIds": "array",
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "legacySidegradeConfirmationButton": {
    "name": "legacy-sidegrade-confirmation-button",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked",
        "viewed"
      ],
      "productName": "string",
      "trackingSource": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "carouselInteraction": {
    "name": "carousel-interaction",
    "class": "interaction",
    "properties": {
      "sourceId": "string",
      "action": [
        "next-image",
        "previous-image",
        "expand-image",
        "jump-to-image"
      ],
      "imageId": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "talkToSales": {
    "name": "talk-to-sales-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "productName": "string",
      "skuId": "number",
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthprofessional",
          "growthenterprise",
          "bundle",
          "marketingstartercms",
          "growthstarter-covid"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "upgradeProduct": {
        "type": "string"
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "buyClick": {
    "name": "buy-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "productNames": "array",
      "skuIds": "array",
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthstarter-covid"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "bundledOffer": {
        "type": "string",
        "isOptional": true
      },
      "upgradeProduct": {
        "type": "string"
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "signupClick": {
    "name": "signup-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "signupType": {
        "type": [
          "crm",
          "marketing",
          "sales",
          "service"
        ]
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  },
  "publicExperimentExposure": {
    "name": "experiment-exposure",
    "class": "exposure",
    "properties": {
      "treatmentKey": "string",
      "experimentParams": "array",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-unified-ui"
  }
};